<template>
  <div class="coming-soon-wrapper">
    <div class="container">
      <span class="icon">🏗️</span>
      <h1>Coming Soon</h1>
      <div class="line"></div>
      <p class="subtitle">We're building something awesome</p>
      <!-- <p class="description">
        Subscribe to get notified when we launch. No spam, just one email.
      </p>
      
      <form class="email-form" @submit.prevent="handleSubscribe">
        <input 
          type="email" 
          v-model="email" 
          placeholder="Enter your email" 
          required
        >
        <button type="submit">Subscribe</button>
      </form> -->
      
      <p class="footer">© {{ date }}. All rights reserved.</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      date: new Date().getFullYear(),
    };
  },
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.coming-soon-wrapper {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  color: #1a1a2e;
  padding: 20px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}

.container {
  text-align: center;
  max-width: 500px;
  animation: fadeInUp 0.8s ease-out;
  width: 100%;
  padding: 20px;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.icon {
  font-size: 80px;
  margin-bottom: 20px;
  display: block;
}

h1 {
  font-size: 42px;
  font-weight: 700;
  margin-bottom: 10px;
  letter-spacing: -1px;
  color: #1a1a2e;
}

.subtitle {
  font-size: 18px;
  color: #666;
  margin-bottom: 25px;
}

.line {
  width: 40px;
  height: 3px;
  background: #1a1a2e;
  margin: 20px auto;
  border-radius: 2px;
}

.description {
  font-size: 15px;
  color: #888;
  line-height: 1.8;
  margin-bottom: 30px;
}

.email-form {
  display: flex;
  gap: 10px;
  max-width: 400px;
  margin: 0 auto;
}

.email-form input {
  flex: 1;
  padding: 12px 18px;
  border: 2px solid #eee;
  border-radius: 8px;
  font-size: 15px;
  outline: none;
  transition: border-color 0.3s;
  background: white;
}

.email-form input:focus {
  border-color: #1a1a2e;
}

.email-form button {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  background: #1a1a2e;
  color: white;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  white-space: nowrap;
}

.email-form button:hover {
  background: #2d2d4a;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0,0,0,0.1);
}

.footer {
  margin-top: 40px;
  font-size: 13px;
  color: #ccc;
}

@media (max-width: 480px) {
  h1 {
    font-size: 32px;
  }
  
  .email-form {
    flex-direction: column;
  }
  
  .email-form button {
    width: 100%;
  }
}
</style>